import { render, staticRenderFns } from "./pos-articles.vue?vue&type=template&id=04931d02&scoped=true&"
import script from "./pos-articles.ts?vue&type=script&lang=ts&"
export * from "./pos-articles.ts?vue&type=script&lang=ts&"
import style0 from "./pos-articles.scss?vue&type=style&index=0&id=04931d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04931d02",
  null
  
)

export default component.exports